import Vue from 'vue';
import { post, get, upfile } from './requset';
import url from './url'
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$upfile = upfile;
Vue.prototype.url = url.url;
Vue.prototype.upload_url = url.upload_url;
Vue.prototype.url_no = url.url_no;